import { useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { littersData as staticLitters } from '../data/litters';
import { fetchLitters } from '../lib/api';
import { useSupabaseData } from '../lib/useSupabaseData';
import { img } from '../lib/img';
import PhotoGallery from '../components/PhotoGallery';
import { Reveal, RevealHeading } from '../components/Reveal';

const LitterProfilePage = () => {
  const { litterId } = useParams();
  const { t, i18n } = useTranslation();
  const { data: littersData, loading } = useSupabaseData(fetchLitters, staticLitters, 'litters');

  const litter = littersData.find((l) => l.id === litterId);

  if (!litter) {
    if (loading) return null;
    return <div className="py-20 text-center text-brand-text-light">{t('litters.not_found')}</div>;
  }

  const description = i18n.language === 'pl' ? litter.description.pl : litter.description.en;

  return (
    <div className="animate-fadeIn mx-auto max-w-5xl px-4">
      <section className="my-12 md:my-20">
        <div className="mb-12 text-center">
          <RevealHeading as="h1" text={`Miot ${litter.letter}`} className="text-4xl text-brand-accent md:text-5xl" />
          {litter.date && (
            <Reveal as="p" delay={0.18} className="mt-2 text-lg text-brand-text-light/70">{litter.date}</Reveal>
          )}
        </div>

        <div className="mb-12 flex justify-center">
          <motion.div
            layoutId={`litter-image-${litterId}`}
            className="w-full max-w-2xl overflow-hidden rounded-lg bg-brand-bg-side shadow-2xl ring-1 ring-brand-accent/20"
          >
            <img
              src={img(litter.presentationImage, { w: 1000 })}
              alt={`Miot ${litter.letter}`}
              decoding="async"
              className="h-auto w-full object-contain"
            />
          </motion.div>
        </div>

        <Reveal as="div" className="mx-auto mb-14 max-w-3xl whitespace-pre-line text-center leading-relaxed text-brand-text-light/85">
          {description}
        </Reveal>

        <RevealHeading as="h2" text={t('ourDogs.profile.gallery_title')} className="mb-8 text-center text-3xl text-brand-accent" />

        <PhotoGallery
          images={litter.gallery}
          alt={`Miot ${litter.letter}`}
          layout="grid"
          thumbWidth={500}
          emptyText={t('ourDogs.profile.no_images')}
        />
      </section>
    </div>
  );
};

export default LitterProfilePage;
